module.exports = __webpack_public_path__ + "assets/202509252035/img/archived.d62471d8.png";